import { apiDadataService } from '@/services/APIService';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';

import DadataAddress from '../list/dadata/address';

export const DadataManager = {
  async suggestAddresses({ data = {} } = DEFAULT_PARAMS) {
    const response = await apiDadataService.post('/suggest/address', data);

    return {
      response,
      items: (response?.data?.suggestions || []).map((item) => new DadataAddress(item)),
    };
  },
};
